export const BUILD_TYPE = process.env.REACT_APP_BUILD_TYPE;

export const JWT_API = {
    secret: 'SECRET-KEY',
    timeout: '1 days'
};

export const VIEW_TYPE_MY_DASHBOARD = 'My Dashboard';
export const VIEW_TYPE_REQUIREMENTS_FUNNEL = 'Requirments Funnel';

export const FIREBASE_API = {
    apiKey: 'AIzaSyBernKzdSojh_vWXBHt0aRhf5SC9VLChbM',
    authDomain: 'berry-material-react.firebaseapp.com',
    projectId: 'berry-material-react',
    storageBucket: 'berry-material-react.appspot.com',
    messagingSenderId: '901111229354',
    appId: '1:901111229354:web:a5ae5aa95486297d69d9d3',
    measurementId: 'G-MGJHSL8XW3'
};

export const AUTH0_API = {
    client_id: '7T4IlWis4DKHSbG8JAye4Ipk0rvXkH9V',
    domain: 'dev-w0-vxep3.us.auth0.com'
};

export const AWS_API = {
    poolId: 'us-east-1_AOfOTXLvD',
    appClientId: '3eau2osduslvb7vks3vsh9t7b0'
};

// basename: only at build time to set, and Don't add '/' at end off BASENAME for breadcrumbs, also Don't put only '/' use blank('') instead,
// like '/berry-material-react/react/default'
export const BASE_PATH = '';

export const DASHBOARD_PATH = '/dashboard/default';
export const ARYABHATTA_API_DOMAIN_V1 = process.env.REACT_APP_ARYABHATTA_API_DOMAIN_V1;
export const ON_TRIP_SURVEY_ENTITY_TYPE = process.env.REACT_APP_ENTITY_TYPE;
export const COGNITO_LOGIN_URL = process.env.REACT_APP_COGNITO_LOGIN_URL;
export const DOCS_API_DOMAIN = process.env.REACT_APP_DOCS_API_DOMAIN;
export const LMS_API_DOMAIN = process.env.REACT_APP_LMS_API_DOMAIN;
export const FLIGHT_PUSH_BOOKING = process.env.REACT_APP_FLIGHT_PUSH_BOOKING;
export const AI_SERVICE_URL = process.env.REACT_APP_AI_SERVICE_API_DOMAIN;
export const COGNITO_LOGIN_AUTOATION_TEST_URL = process.env.REACT_APP_COGNITO_LOGIN_AUTOATION_TEST_URL;
export const NOTIFICATION_INTERNAL_COMMENTING_FIREBASE_URL = process.env.REACT_APP_INTERNAL_COMMENTING_NOTIFICATION;
export const CHAT_INTERNAL_COMMENTING_FIREBASE_LISTENING_URL = process.env.REACT_APP_CHAT_LISTENER_NAME;
export const COUPONS_API_DOMAIN = process.env.REACT_APP_COUPONS_API_DOMAIN;
export const AUTO_QUOTE_CONSTANT = 'auto-quote';
export const AUTO_SUGGEST_CONSTANT = 'autosuggest';
export const SIGHTSEEINGS_CONSTANT = 'sightseeings';
export const TENTATIVE_PENDING_VOUCHER_BASE_URL = process.env.REACT_APP_TENTATIVE_PENDING_VOUCHER_BASE_URL;
export const isProdEnv = BUILD_TYPE === 'production' || BUILD_TYPE === 'uat';

const config = {
    fontFamily: `'Roboto', sans-serif`,
    borderRadius: 8,
    outlinedFilled: true,
    navType: 'light', // light, dark
    presetColor: 'default', // default, theme1, theme2, theme3, theme4, theme5, theme6
    locale: 'en', // 'en' - English, 'fr' - French, 'ro' - Romanian, 'zh' - Chinese
    rtlLayout: false,
    container: false
};

export const FREEMEAL_BOARDBASIS_TYPES_DESC = {
    BedAndBreakfast: 'Breakfast',
    HalfBoard: 'Half Board',
    FullBoard: 'Full Board',
    AllInclusive: 'All Inclusive'
};
export default config;
